import { useQuery } from '@tanstack/react-query'
import { useMapLoaded } from '@/components/regionen/pageRegionSlug/hooks/mapState/useMapState'
import { useCurrentMode } from '@/components/regionen/pageRegionSlug/modes/useCurrentMode'
import { osmNotesQueryOptions } from './osmNotesQueryOptions'
import { useNotesActiveByZoom } from './useNotesActiveByZoom'
import { useNotesSelection } from './useNotesSelection'
import { useOsmNotesBbox } from './useOsmNotesBbox'

/** Shared OSM-notes query; `enabled` is the fetch gate, cached/placeholder data still reads. */
export const useOsmNotesQuery = () => {
  const mapLoaded = useMapLoaded()
  const currentMode = useCurrentMode()
  const notesActiveByZoom = useNotesActiveByZoom()
  const bbox = useOsmNotesBbox()
  const selection = useNotesSelection()

  return useQuery({
    ...osmNotesQueryOptions({ bbox }),
    enabled:
      mapLoaded &&
      Boolean(bbox) &&
      currentMode.isNotes &&
      selection.kind === 'osm' &&
      notesActiveByZoom,
  })
}
